export default __webpack_public_path__ + "static/ABA_2020-Finalist_Commercial Broker of the Year-04dbe35ce7772ca5add076ea480cddfd.png";